<div class="pdf-field-preview" [style.fontSize.px]="fontSize">
  <ng-container *ngIf="!hasOverride">
    <span *ngIf="showLabel && label" class="field-label">{{ label }}:</span>
    <span class="field-value">{{ displayValue }}</span>
  </ng-container>
  <span *ngIf="hasOverride" class="field-value">{{ displayValue }}</span>
</div>
